<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>

          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >FAQ
          </li>
        </ul>
        <div class="col text">
          <h1>Veelgestelde vragen</h1>
          <p>
            Veel vragen zijn ons al eens gesteld. Daarom hebben we de antwoorden
            op de meest gestelde vragen op een rijtje gezet. Staat het antwoord
            op uw vraag er niet tussen? Neem dan gerust
            <router-link to="contact" class="link-text"> contact</router-link>
            met ons op.
          </p>
        </div>
        <div class="col image">
          <img class="ben" src="@/images/pages/ben-met-pc.svg" />
          <div class="bg-circle g-w"></div>
        </div>
      </section>
      <section id="bestellen" class="row faq-holder">
        <h1>Bestellen</h1>
        <div class="question">
          <h2>Hoe kan ik printproducten bestellen?</h2>
          <p>
            Printproducten bestellen kan via onze website (ook op uw mobiel), op
            de <router-link to="/" class="link-text"> homepage</router-link>. U
            kunt hier exact aangeven wat u wilt bestellen, welke afwerking u
            wenst, waar u het product bezorgd wilt hebben en hoe het product
            gefactureerd mag worden. Wanneer u meer begeleiding wenst, kunt u
            ook mailen of langskomen. Rijnja regelt het!
          </p>
        </div>
        <div class="question">
          <h2>Kan ik ook een offerte aanvragen?</h2>
          <p>
            Zeker. Op de
            <router-link to="/" class="link-text"> homepage</router-link> heeft
            u ook de mogelijkheid om ‘Offerte aanvragen’ te selecteren. U kunt
            hier een opdrachtbeschrijving invoeren en daar een offerte voor
            aanvragen. Natuurlijk kunt u ook altijd
            <router-link to="contact" class="link-text"> contact</router-link>
            met ons opnemen om een offerte aan te vragen.
          </p>
        </div>

        <div class="question">
          <h2>Welke prijzen hanteren jullie?</h2>
          <p>
            Rijnja werkt niet met vaste prijzen omdat wij printen op maat. Voor
            een prijsafspraak kunt u daarom het beste even
            <router-link to="contact" class="link-text"> contact</router-link>
            met ons opnemen.
          </p>
        </div>

        <div class="question">
          <h2>Welke producten kan ik bij jullie laten printen?</h2>
          <p>
            Rijnja print bijna alles. Van banieren tot brochures en van stickers
            tot bouwtekeningen. Op onze website ziet u al verschillende
            standaard producten staan binnen de printopdracht onder knop
            "Templates". Mocht u een ander type product willen laten printen,
            neem dan gerust
            <router-link to="contact" class="link-text"> contact</router-link>
            met ons op. We helpen u graag verder.
          </p>
        </div>

        <div class="question">
          <h2>Welke afwerkmogelijkheden zijn er?</h2>
          <p>
            Op onze website kunt u uit verschillende afwerkmogelijkheden kiezen.
            Zo kunt u bij printen op maat standaard keuzes maken in het formaat
            (A0 tot A6), kleur of zwart-wit, 1- of 2-zijdig, materiaal (MC Gloss
            115 tot 270g, Off-white 80-300g of Tyvek) en de afwerking (rollen,
            nieten, vouwen, ringband of boren).
          </p>
          <p>
            Voor printproducten zoals posters, flyers, banners, visitekaartjes
            en rapporten, zijn er nog diverse andere keuzemogelijkheden.
          </p>
        </div>

        <div class="question">
          <h2>Hoe moet ik mijn bestanden aanleveren?</h2>
          <p>
            Wij raden u aan om uw bestand aan te leveren als printklare pdf. Bij
            problemen of vragen helpen onze medewerkers u graag verder. Neem
            gerust
            <router-link to="contact" class="link-text"> contact</router-link>
            met ons op.
          </p>
        </div>
      </section>
      <section id="levering" class="row faq-holder">
        <h1>Levering</h1>
        <div class="question">
          <h2>Wat zijn jullie levertijden?</h2>
          <p>
            Bij Rijnja wordt 99% van de orders de volgende werkdag bezorgd. Onze
            koeriers bezorgen 2 keer per dag.
          </p>
        </div>

        <div class="question">
          <h2>Wie levert de producten?</h2>
          <p>
            Printproducten worden bezorgd door onze eigen koeriers, die rijden
            in volledig elektrisch aangedreven bestelauto’s. Zo zijn we nooit
            afhankelijk van het distributienetwerk van een externe partij.
          </p>
        </div>

        <div class="question">
          <h2>Waar bezorgen jullie?</h2>
          <p>
            Wij bezorgen door heel Nederland.
          </p>
        </div>
      </section>
      <section id="facturatie" class="row faq-holder">
        <h1>Facturatie</h1>

        <div class="question">
          <h2>Hoe gaat de facturatie in z’n werk?</h2>
          <p>
            Wanneer u een account hebt bij Rijnja, wordt al het werk op rekening
            uitgevoerd. De facturatie vindt achteraf plaats met een
            betaaltermijn van 30 dagen. Rijnja kan facturen aanleveren in PDF of
            in XML, zodat ze makkelijk leesbaar zijn voor het
            administratiesysteem van uw organisatie.
          </p>
        </div>

        <div class="question">
          <h2>Wat is de betaaltermijn?</h2>
          <p>
            Wij hanteren een betaaltermijn van 30 dagen.
          </p>
        </div>
      </section>

      <section id="overig" class="row faq-holder">
        <h1>Materialen signing</h1>

        <div class="question">
          <h2>Wat zijn de eigenschappen van een sticker?</h2>
          <ul>
            <li>
              Hecht aan ieder oppervlak
            </li>
            <li>
              Verwijderbaar zonder lijmresten (binnen 3 maanden)
            </li>
          </ul>
        </div>

        <div class="question">
          <h2>Wat zijn de eigenschappen van een vloersticker?</h2>
          <ul>
            <li>
              Slijtvaste afbeelding
            </li>
            <li>
              Anti-slip
            </li>
            <li>
              Extra hoge kleefkracht
            </li>
          </ul>
        </div>

        <div class="question">
          <h2>Wat zijn de eigenschappen van een magneetsticker?</h2>
          <ul>
            <li>
              Magnetische folie
            </li>
            <li>
              Makkelijk te verwijderen
            </li>
            <li>
              Herbruikbaar
            </li>
          </ul>
        </div>

        <div class="question">
          <h2>Wat zijn de eigenschappen van een reflecterende sticker?</h2>
          <ul>
            <li>
              Veiligheidsklasse 3
            </li>
            <li>
              Geschikt voor buitengebruik
            </li>
            <li>
              Permanent hechtend
            </li>
          </ul>
        </div>

        <div class="question">
          <h2>Wat zijn de eigenschappen van forex?</h2>
          <ul>
            <li>
              Bord van gerecycled kunststof
            </li>
            <li>
              Licht in gewicht
            </li>
            <li>
              Enigszins buigzaam
            </li>
            <li>
              Geschikt voor buitengebruik (tot ca. 1 jaar)
            </li>
          </ul>
        </div>

        <div class="question">
          <h2>Wat zijn de eigenschappen van dibond?</h2>
          <ul>
            <li>
              Aluminium sandwichpaneel
            </li>
            <li>
              Licht in gewicht
            </li>
            <li>
              Extra stevig, vormvast
            </li>
            <li>
              Geschikt voor langdurig buitengebruik
            </li>
          </ul>
        </div>
      </section>

      <section id="overig" class="row faq-holder">
        <h1>Overig</h1>

        <div class="question">
          <h2>
            Welke eisen stellen jullie aan de kwaliteit van producten en
            processen?
          </h2>
          <p>
            Wij vinden het belangrijk dat we producten van hoogwaardige
            kwaliteit leveren en de klanttevredenheid op een hoog niveau houden.
            Omdat we dit willen kunnen aantonen, zijn we NEN-ISO 9001
            gecertificeerd.
          </p>
        </div>

        <div class="question">
          <h2>
            Wat doen jullie op gebied van duurzaamheid?
          </h2>
          <p>
            Rijnja heeft oog voor mens, milieu en maatschappij. Daarom zijn wij
            ISO 14001:2015 en FSC gecertificeerd.
          </p>
        </div>

        <!-- <div class="question">
          <h2>
            Wat doen jullie aan informatiebeveiliging?
          </h2>
          <p>
            Wij willen dat onze klanten hun documenten met een gerust hart bij
            ons laten printen, ook als er gevoelige informatie in de documenten
            staat. Met het ISO/IEC 27001 certificaat tonen wij aan dat de
            veiligheid van het printwerk op verschillende manieren wordt
            geborgd. Je kunt hier meer over lezen op de
            <router-link
              to="/over-rijnja/informatiebeveiliging"
              class="link-text"
              >pagina over informatiebeveiliging</router-link
            >.
          </p>
        </div> -->

        <div class="question">
          <h2>
            Kan ik bij u terecht voor secured printing?
          </h2>
          <p>
            Ja, zeker. Voor het beveiligd laten printen van documenten bent u
            bij ons aan het juiste adres. Op de
            <router-link to="/secured-printing" class="link-text"
              >pagina over secured printing</router-link
            >
            kunt u er meer over lezen.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
export default {
  components: { SiteFooter },
  // NOTE: meta info off pending input of marketing department
  head() {
    return {
      meta: [
        {
          property: 'og:description',
          content:
            'Veel vragen zijn ons al eens gesteld. Daarom hebben we de antwoorden op de meest gestelde vragen op een rijtje gezet.'
        },
        {
          property: 'og:url',
          content: this.$route.path
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Hoe kan ik printproducten bestellen?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Printproducten bestellen kan via onze website (ook op je mobiel), op de <a href="https://www.rijnja.nl">homepage</a>. Je kunt hier exact aangeven wat je wilt bestellen, welke afwerking je wenst, waar je het product bezorgd wilt hebben en hoe het product gefactureerd mag worden. Als je meer begeleiding wenst, kan je ook mailen of langskomen. Rijnja regelt het!</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Kan ik ook een offerte aanvragen?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Zeker. Op de <a href="https://www.rijnja.nl">homepage</a> heb je ook de mogelijkheid om ‘Offerte aanvragen’ te selecteren. Je kunt hier een opdrachtbeschrijving invoeren en daar een offerte voor aanvragen. Natuurlijk kan je ook altijd <a href="https://www.rijnja.nl/contact">contact</a> met ons opnemen om een offerte aan te vragen.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Welke prijzen hanteren jullie?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Rijnja werkt niet met vaste prijzen omdat wij printen op maat. Voor een prijsafspraak kun je daarom het beste even contact met ons opnemen.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Welke producten kan ik bij jullie laten printen?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Rijnja print bijna alles. Van banieren tot brochures en van stickers tot bouwtekeningen. Op onze website zie je al verschillende standaard producten staan binnen de printopdracht onder knop "Templates". Mocht je een ander type product willen laten printen, neem dan gerust contact met ons op. We helpen je graag verder.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Welke afwerkmogelijkheden zijn er?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Op onze website kun je uit verschillende afwerkmogelijkheden kiezen. Zo kun je bij printen op maat standaard keuzes maken in het formaat (A0 tot A6), kleur of zwart-wit, 1- of 2-zijdig, materiaal (MC Gloss 115 tot 270g, Off-white 80-300g of Tyvek) en de afwerking (rollen, nieten, vouwen, ringband of boren).Voor printproducten zoals posters, flyers, banners, visitekaartjes en rapporten, zijn er nog diverse andere keuzemogelijkheden.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Hoe moet ik mijn bestanden aanleveren?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Wij raden je aan om je bestand aan te leveren als printklare pdf. Bij problemen of vragen helpen onze medewerkers je graag verder. Neem gerust contact met ons op.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn jullie levertijden?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Bij Rijnja wordt 99% van de orders de volgende werkdag bezorgd. Onze koeriers bezorgen 2 keer per dag.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wie levert de producten?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Printproducten worden bezorgd door onze eigen koeriers, die rijden in volledig elektrisch aangedreven bestelauto’s. Zo zijn we nooit afhankelijk van het distributienetwerk van een externe partij.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Waar bezorgen jullie?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '<p>Wij bezorgen door heel Nederland.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Hoe gaat de facturatie in z’n werk?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Als je een account hebt bij Rijnja, wordt al het werk op rekening uitgevoerd. De facturatie vindt achteraf plaats met een betaaltermijn van 30 dagen. Rijnja kan facturen aanleveren in PDF of in XML, zodat ze makkelijk leesbaar zijn voor het administratiesysteem van jouw organisatie.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat is de betaaltermijn?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '<p>Wij hanteren een betaaltermijn van 30 dagen.</p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn de eigenschappen van een sticker?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<ul><li>Hecht aan ieder oppervlak</li><li>Verwijderbaar zonder lijmresten (binnen 3 maanden)</li></ul>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn de eigenschappen van een vloersticker?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<ul><li>Slijtvaste afbeelding</li><li>Anti-slip</li><li>Extra hoge kleefkracht</li></ul>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn de eigenschappen van een magneetsticker?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<ul><li>Magnetische folie</li><li>Makkelijk te verwijderen</li><li>Herbruikbaar</li></ul>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn de eigenschappen van Forex?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<ul><li>Kunststof bord</li><li>Licht in gewicht</li><li>Enigszins buigzaam</li><li>Geschikt voor buitengebruik (tot ca. 1 jaar)</li></ul>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat zijn de eigenschappen van Dibond?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<ul><li>Aluminium sandwichpaneel</li><li>Licht in gewicht</li><li>Extra stevig, vormvast</li><li>Geschikt voor langdurig buitengebruik</li></ul>'
                }
              },
              {
                '@type': 'Question',
                name:
                  'Welke eisen stellen jullie aan de kwaliteit van producten en processen?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Wij vinden het belangrijk dat we producten van hoogwaardige kwaliteit leveren en de klanttevredenheid op een hoog niveau houden. Omdat we dit willen kunnen aantonen, zijn we NEN-ISO 9001 gecertificeerd. Je kunt hier meer over lezen op de <a href="https://www.rijnja.nl/over-rijnja/kwaliteit">pagina over kwaliteit.</a></p>'
                }
              },
              {
                '@type': 'Question',
                name: 'Wat doen jullie op gebied van duurzaamheid?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Rijnja heeft oog voor mens, milieu en maatschappij. Daarom zijn wij ISO 14001:2015 en FSC gecertificeerd. Wat wij doen om bij te dragen aan een schonere toekomst, kun je lezen op de <a href="https://www.rijnja.nl/over-rijnja/duurzaamheid">pagina over duurzaamheid.</a></p>'
                }
              },
              /*  {
                '@type': 'Question',
                name: 'Wat doen jullie aan informatiebeveiliging?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Wij willen dat onze klanten hun documenten met een gerust hart bij ons laten printen, ook als er gevoelige informatie in de documenten staat. Met het ISO/IEC 27001 certificaat tonen wij aan dat de veiligheid van het printwerk op verschillende manieren wordt geborgd. Je kunt hier meer over lezen op de <a href="https://www.rijnja.nl/over-rijnja/informatiebeveiliging">pagina over informatiebeveiliging.</a></p>'
                }
              }, */
              {
                '@type': 'Question',
                name: 'Kan ik bij jullie terecht voor secured printing?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text:
                    '<p>Ja, zeker. Voor het beveiligd laten printen van documenten ben je bij ons aan het juiste adres. Op de <a href="https://www.rijnja.nl/secured-printing">pagina over secured printing</a> kun je er meer over lezen.</p>'
                }
              }
            ]
          })
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.ben {
  max-width: 275px;
}
.row.faq-holder {
  flex-wrap: wrap;
  justify-content: space-between;
  h1 {
    flex: 1 0 auto;
    margin-bottom: 20px;
    padding-left: 28px;
    width: 100%;
  }
}

.extra-text {
  padding: 0 30px 20px;
}

.question {
  width: 100%;
  border-radius: 10px;
  box-shadow: #00000020 0 0 45px -9px;
  padding: 20px 30px;
  margin-bottom: 20px;
  background: white;

  @media only screen and (min-width: 768px) {
    width: calc(50% - 10px);
  }
}

/* .material {
  width: 100%;
  border-radius: 10px;
  box-shadow: #00000020 0 0 45px -9px;
  padding: 20px 30px;
  margin-bottom: 20px;
  background: white;
  display: flex;

  img {
    flex: 0 0 auto;
    &.sticker {
      width: 87px;
    }

    &.vloersticker {
      width: 106px;
    }

    &.magneet {
      width: 108px;
    }

    &.forex {
      width: 112px;
    }

    &.dibond {
      width: 110px;
    }
  }

  div {
    flex-grow: 1;
  }

  @media only screen and (min-width: 768px) {
    width: calc(50% - 10px);
  }
} */
</style>
